export default __webpack_public_path__ + "static/media/back.38eab6cc.svg";